import { defineComponent } from '@vue/composition-api';
import __vue_component__$1 from '../content/Tooltip.vue.js';
import __vue_component__ from '../icons/Icon.vue.js';
import { inputRestrictions } from './constants.js';

/**
 * @deprecated Use SdsInputText, SdsInputSearch, SdsInputPassword, or SdsInputCurrency instead
 */
var script = defineComponent({
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        state: {
            type: String,
            required: false,
            default: '',
        },
        variant: {
            type: String,
            required: false,
            default: 'white',
        },
        className: {
            type: String,
            required: false,
            default: '',
        },
        prefix: {
            type: String,
            required: false,
            default: '',
        },
        name: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: false,
            default: 'text',
        },
        value: {
            type: String,
            required: false,
            default: '',
        },
        label: {
            type: String,
            required: true,
        },
        iconRight: {
            type: String,
            required: false,
            default: '',
        },
        iconRole: {
            type: String,
            required: false,
            default: 'none',
        },
        iconPressed: {
            type: String,
            required: false,
            default: 'undefined',
        },
        hasTooltip: {
            type: Boolean,
            required: false,
            default: false,
        },
        tooltipText: {
            type: String,
            required: false,
            default: '',
        },
        isMessageRight: {
            type: Boolean,
            required: false,
            default: false,
        },
        isMessagePlainText: {
            type: Boolean,
            required: false,
            default: true,
        },
        isInputRestricted: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    data: function () {
        return {
            isInputEmpty: !this.value,
        };
    },
    methods: {
        onFocus: function (event) {
            this.$emit('focus', event);
        },
        onBlur: function (event) {
            this.$emit('blur', this.value);
            this.checkValue(event);
        },
        checkValue: function (event) {
            var inputValue = event.target.value;
            if (inputValue.trim() === '' && !this.value) {
                this.isInputEmpty = true;
            }
            else {
                this.isInputEmpty = false;
            }
        },
        preventRestrictedChars: function (event) {
            if (this.isInputRestricted &&
                inputRestrictions[this.type] &&
                event.data &&
                !event.data.match(inputRestrictions[this.type])) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
        },
        updateValue: function (event) {
            var value = event.target.value;
            this.$emit('valueChanged', value);
            this.$emit('input', value);
        },
        focusInput: function () {
            var _a;
            (_a = this.$refs['input']) === null || _a === void 0 ? void 0 : _a.focus();
        },
        moveCaretToEnd: function () {
            var _a, _b;
            var el = this.$refs['input'];
            el.setSelectionRange(((_a = el.value) === null || _a === void 0 ? void 0 : _a.length) || 0, ((_b = el.value) === null || _b === void 0 ? void 0 : _b.length) || 0);
        }
    },
    computed: {
        showIcon: function () {
            return this.state === 'error' || this.state === 'success' || this.iconRight;
        },
        iconClass: function () {
            var _a;
            return _a = {
                    'icon-warning_triangle_filled icon--error': this.state === 'error',
                    'icon-check_circle_filled icon--success': this.state === 'success'
                },
                _a[this.iconRight] = this.state !== 'error' && this.state !== 'success' && this.iconRight,
                _a;
        }
    },
    components: {
        Icon: __vue_component__,
        Tooltip: __vue_component__$1,
    },
});

export default script;
